var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}function ownKeys(e, r) {var t = Object.keys(e);if (Object.getOwnPropertySymbols) {var o = Object.getOwnPropertySymbols(e);r && (o = o.filter(function (r) {return Object.getOwnPropertyDescriptor(e, r).enumerable;})), t.push.apply(t, o);}return t;}function _objectSpread(e) {for (var r = 1; r < arguments.length; r++) {var t = null != arguments[r] ? arguments[r] : {};r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {_defineProperty(e, r, t[r]);}) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));});}return e;}function _defineProperty(obj, key, value) {key = _toPropertyKey(key);if (key in obj) {Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true });} else {obj[key] = value;}return obj;}function _toPropertyKey(t) {var i = _toPrimitive(t, "string");return "symbol" == typeof i ? i : i + "";}function _toPrimitive(t, r) {if ("object" != typeof t || !t) return t;var e = t[Symbol.toPrimitive];if (void 0 !== e) {var i = e.call(t, r || "default");if ("object" != typeof i) return i;throw new TypeError("@@toPrimitive must return a primitive value.");}return ("string" === r ? String : Number)(t);} /* eslint-disable max-lines */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/no-multi-comp */
import { MultiSelect } from "../../../Forms";

import React from 'react';
import { connect } from 'react-redux';


const edgeStylesBase = {
  styles: {
    width: '10px',
    flexGrow: '1'
  },
  lineWidth: 1,
  getLineStyle: (multiplier) => `solid ${multiplier * edgeStylesBase.lineWidth}px black`
};

const edgeStyles = {
  noVertical: {
    top: _objectSpread(_objectSpread({},
    edgeStylesBase.styles), {}, {
      borderBottom: edgeStylesBase.getLineStyle(1) }),

    bottom: _objectSpread(_objectSpread({},
    edgeStylesBase.styles), {}, {
      borderTop: edgeStylesBase.getLineStyle(1) })

  },
  withVertical: {
    left: {
      top: _objectSpread(_objectSpread({},
      edgeStylesBase.styles), {}, {
        borderBottom: edgeStylesBase.getLineStyle(1),
        borderLeft: edgeStylesBase.getLineStyle(2) }),

      bottom: _objectSpread(_objectSpread({},
      edgeStylesBase.styles), {}, {
        borderTop: edgeStylesBase.getLineStyle(1),
        borderLeft: edgeStylesBase.getLineStyle(2) })

    }
  }
};

const edgeContainerStyles = {
  display: 'flex',
  flexDirection: 'column'
};

const boxStyles = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'stretch'
};

const nodeContainerStyles = {
  display: 'flex',
  alignItems: 'center'
};

const nodeStyles = {
  border: 'solid 1px black',
  borderRadius: '3px',
  padding: '3px',
  marginTop: '3px',
  marginBottom: '3px',
  display: 'flex',
  flexDirection: 'column'
};

const childrenStyles = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center'
};







const Edges = ({ isFirst, isLast, isRight }) => {
  if (isRight || isFirst && isLast) {
    return /*#__PURE__*/(
      _jsx("div", { style: edgeContainerStyles }, void 0, /*#__PURE__*/
      _jsx("div", { style: edgeStyles.noVertical.top }), /*#__PURE__*/
      _jsx("div", { style: edgeStyles.noVertical.bottom })
      ));

  }

  return /*#__PURE__*/(
    _jsx("div", { style: edgeContainerStyles }, void 0,
    isFirst ? /*#__PURE__*/
    _jsx("div", { style: edgeStyles.noVertical.top }) : /*#__PURE__*/

    _jsx("div", { style: edgeStyles.withVertical.left.top }),

    isLast ? /*#__PURE__*/
    _jsx("div", { style: edgeStyles.noVertical.bottom }) : /*#__PURE__*/

    _jsx("div", { style: edgeStyles.withVertical.left.bottom })

    ));

};






const AddElement = ({ isFirst, onClick }) => /*#__PURE__*/
_jsx("div", { style: boxStyles }, void 0, /*#__PURE__*/
_jsx(Edges, { isFirst: isFirst, isLast: true }), /*#__PURE__*/
_jsx("div", { style: nodeContainerStyles }, void 0, /*#__PURE__*/
_jsx("div", { style: _objectSpread(_objectSpread({}, nodeStyles), {}, { border: 'none' }) }, void 0, /*#__PURE__*/
_jsx("input", { type: "button", value: "+", onClick: onClick })
)
)
);












const Node = ({
  caption,
  isFirst,
  isLast,
  nested,
  children,
  onAddElementHandler,
  onDeleteElementHandler,
  deleteDisabled
}) => /*#__PURE__*/
_jsx("div", { style: boxStyles }, void 0, /*#__PURE__*/
_jsx(Edges, { isFirst: isFirst, isLast: isLast }), /*#__PURE__*/
_jsx("div", { style: nodeContainerStyles }, void 0, /*#__PURE__*/
_jsx("div", { style: nodeStyles }, void 0, /*#__PURE__*/
_jsx("div", {
  style: {
    float: 'left',
    borderBottom: 'solid 1px lightgrey',
    marginBottom: '5px',
    paddingBottom: '5px'
  } }, void 0, /*#__PURE__*/

_jsx("span", { style: { marginRight: '5px' } }, void 0, caption), /*#__PURE__*/
_jsx("input", {
  type: "button",
  value: "x",
  onClick: onDeleteElementHandler,
  disabled: deleteDisabled }
)
),
children
)
),
nested.length ? /*#__PURE__*/_jsx(Edges, { isRight: true }) : null, /*#__PURE__*/
_jsx("div", { style: childrenStyles }, void 0,
nested, /*#__PURE__*/
_jsx(AddElement, { isFirst: nested.length === 0, onClick: onAddElementHandler })
)
);


const createDefaultTraversal = () => (
{
  direction: 'out',
  types: [],
  match: [
  {
    templates: []
  }]

});












const MatchNodeComponent = ({
  value,
  isFirst,
  isLast,
  onChange,
  onDelete,
  templates,
  path,
  canDelete
}) => {var _value$traverse4;
  const createOnChildChangeHandler = (index) => (newTraverseValue) => {var _value$traverse;
    const traverses = [...((_value$traverse = value.traverse) !== null && _value$traverse !== void 0 ? _value$traverse : [])];
    traverses[index] = newTraverseValue;
    onChange(_objectSpread(_objectSpread({}, value), {}, { traverse: traverses }));
  };

  const createOnDeleteChildHandler = (index) => () => {var _value$traverse2;
    onChange(_objectSpread(_objectSpread({}, value), {}, { traverse: (_value$traverse2 = value.traverse) === null || _value$traverse2 === void 0 ? void 0 : _value$traverse2.filter((_m, i) => i !== index) }));
  };

  const onTemplatesChangeHandler = (newTemplates) =>
  onChange(_objectSpread(_objectSpread({}, value), {}, { templates: newTemplates }));

  const onAddElementHandler = () => {var _value$traverse3;return (
      onChange(_objectSpread(_objectSpread({},
      value), {}, {
        traverse: [...((_value$traverse3 = value.traverse) !== null && _value$traverse3 !== void 0 ? _value$traverse3 : []), createDefaultTraversal()] })
      ));};

  return /*#__PURE__*/(
    _jsx(Node, {
      caption: "Match entities",
      isFirst: isFirst,
      isLast: isLast,
      nested:
      ((_value$traverse4 = value.traverse) === null || _value$traverse4 === void 0 ? void 0 : _value$traverse4.map((traversal, index) => /*#__PURE__*/
      _jsx(TravesalNode, {

        value: traversal,
        isFirst: index === 0,
        onChange: createOnChildChangeHandler(index),
        onDelete: createOnDeleteChildHandler(index),
        path: `${path}.${index}` }, index
      )
      )) || [],

      onAddElementHandler: onAddElementHandler,
      onDeleteElementHandler: onDelete,
      deleteDisabled: !canDelete }, void 0, /*#__PURE__*/

    _jsx(MultiSelect, {
      prefix: path,
      onChange: onTemplatesChangeHandler,
      options: templates,
      value: value.templates,
      optionsValue: "_id",
      optionsLabel: "name" }
    )
    ));

};

const MatchNode = connect((state) => ({
  templates: state.templates.toJS()
}))(MatchNodeComponent);











const TravesalNodeComponent = ({
  value,
  isFirst,
  isLast,
  onChange,
  onDelete,
  relationTypes,
  path
}) => {
  const createOnChildChangeHandler = (index) => (newMatchValue) => {
    const matches = [...value.match];
    matches[index] = newMatchValue;
    onChange(_objectSpread(_objectSpread({}, value), {}, { match: matches }));
  };

  const createOnDeleteChildHandler = (index) => () => {
    onChange(_objectSpread(_objectSpread({}, value), {}, { match: value.match.filter((_m, i) => i !== index) }));
  };

  const onAddElementHandler = () => {var _value$match;return (
      onChange(_objectSpread(_objectSpread({},
      value), {}, {
        match: [
        ...((_value$match = value.match) !== null && _value$match !== void 0 ? _value$match : []),
        {
          templates: [],
          traverse: []
        }] })

      ));};

  const onDirectionChangeHandler = (event) =>
  onChange(_objectSpread(_objectSpread({}, value), {}, { direction: event.target.value }));

  const onTypesChangeHandler = (types) => onChange(_objectSpread(_objectSpread({}, value), {}, { types }));

  return /*#__PURE__*/(
    _jsx(Node, {
      caption: "Traverse relationships",
      isFirst: isFirst,
      isLast: isLast,
      nested: value.match.map((match, index) => /*#__PURE__*/
      _jsx(MatchNode, {

        value: match,
        isFirst: index === 0,
        onChange: createOnChildChangeHandler(index),
        onDelete: createOnDeleteChildHandler(index),
        path: `${path}.${index}`,
        canDelete: value.match.length > 1 }, index
      )
      ),
      onAddElementHandler: onAddElementHandler,
      onDeleteElementHandler: onDelete }, void 0, /*#__PURE__*/

    _jsx("select", { value: value.direction, onChange: onDirectionChangeHandler }, void 0, /*#__PURE__*/
    _jsx("option", { value: "out" }, void 0, '-- out -->'), /*#__PURE__*/
    _jsx("option", { value: "in" }, void 0, '<-- in --')
    ), /*#__PURE__*/
    _jsx(MultiSelect, {
      prefix: path,
      onChange: onTypesChangeHandler,
      options: relationTypes,
      value: value.types,
      optionsValue: "_id",
      optionsLabel: "name" }
    )
    ));

};

const TravesalNode = connect((state) => ({
  relationTypes: state.relationTypes.toJS()
}))(TravesalNodeComponent);






export const RelationshipsQueryBuilder = ({ value, onChange }) => {
  const createOnChildChangeHandler = (index) => (newTraverseValue) => {
    const traverses = [...(value !== null && value !== void 0 ? value : [])];
    traverses[index] = newTraverseValue;
    onChange(traverses);
  };

  const createOnDeleteChildHandler = (index) => () => {
    onChange((value !== null && value !== void 0 ? value : []).filter((_m, i) => i !== index));
  };

  const onAddElementHandler = () => onChange([...(value !== null && value !== void 0 ? value : []), createDefaultTraversal()]);

  return /*#__PURE__*/(
    _jsx("div", { className: "form-control", style: _objectSpread(_objectSpread({}, boxStyles), {}, { height: 'unset', overflowX: 'scroll' }) }, void 0, /*#__PURE__*/
    _jsx("div", { style: nodeContainerStyles }, void 0, /*#__PURE__*/
    _jsx("div", {
      style: _objectSpread(_objectSpread({},
      nodeStyles), {}, {
        width: '50px',
        height: '50px',
        borderRadius: '50px',
        marginTop: 0 }) }

    )
    ),
    value !== null && value !== void 0 && value.length ? /*#__PURE__*/_jsx(Edges, { isRight: true }) : null, /*#__PURE__*/
    _jsx("div", { style: childrenStyles }, void 0,
    value === null || value === void 0 ? void 0 : value.map((traversal, index) => /*#__PURE__*/
    _jsx(TravesalNode, {

      value: traversal,
      isFirst: index === 0,
      onChange: createOnChildChangeHandler(index),
      onDelete: createOnDeleteChildHandler(index),
      path: `${index}` }, index
    )
    ), /*#__PURE__*/
    _jsx(AddElement, { isFirst: !(value !== null && value !== void 0 && value.length), onClick: onAddElementHandler })
    )
    ));

};